import script from "./Holidays.vue?vue&type=script&setup=true&lang=js"
export * from "./Holidays.vue?vue&type=script&setup=true&lang=js"

import "./Holidays.vue?vue&type=style&index=0&id=3c4a82d2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c4a82d2"]])

export default __exports__